export interface WhatsappButtonModel {
  type: string;
  text: string;
  url: string;
  phone_Number: string;
}
